import { render, staticRenderFns } from "./BotaoScrollDocumento.vue?vue&type=template&id=51bb5f40&scoped=true"
import script from "./BotaoScrollDocumento.vue?vue&type=script&lang=js"
export * from "./BotaoScrollDocumento.vue?vue&type=script&lang=js"
import style0 from "./BotaoScrollDocumento.vue?vue&type=style&index=0&id=51bb5f40&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb5f40",
  null
  
)

export default component.exports